(function (global) {

  /**
  * Некоторые значение в localStorage устаревают от версии к версии. здесь можно 
  * их очистить.
  */
  var clearOldTemplates = function (oldVersion, newVersion) {
    log.info('MIGRATION', 'Removing old templates from localStorage');

    for (var k in localStorage) {
      // Шаблоны пока ни как не отличаются от других элементов хранилища, отличить их можно только так.
      if (k.indexOf('.html') !== -1) {
        WA.cache.removeItem(k);
      }
    }

  };

  global.handlers.push(clearOldTemplates);

})(Core.migration);